<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Promotions</h1>
                    <p>Gestion des coupons de connexion</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxshop.discount.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer une promo</span>
                </li>
              </actions-dropdown>


            </div>
        </header>

        <filters v-model="filters" :paginator="paginator" active-advanced-filter="false" active-tabs="false" @refresh="refresh()" @setFilter="setFilter"></filters>

        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div class="center">
                          <datagrid-sort :data="[{name:'ID', value:'id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Montant', value:'value'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div>
                          <datagrid-sort :data="[{name:'Publication', value:'publication_state_id'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div><span>Scopes</span></div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)" v-bind:class="setClassDataRaw( 'weeboxshop.discount.view', item.id )">
                        <div></div>
                        <div class="picture no-radius">
                            <figure>
                              <icon name="percent-03"/>
                            </figure>
                        </div>
                        <div data-field="id" class="center"><span class="id">{{ item.id }}</span></div>
                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                        <div data-field="value">{{ item.value }}{{ item.is_number?'.-':'%' }}</div>
                        <div><published v-model="item.published" :date-start="item.start_at"  :date-end="item.end_at"></published></div>
                        <div data-field="scope"><scopes v-model="item.scopes" v-if="item.scopes"></scopes></div>
                        <div class="actions">
                            <ul>
                                <li v-if="$aclInterfaceValidator('weeboxshop.discount.update', item.id)"><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.discount.update',item.id)"><button @click="duplicate(item.id)" title="Dupliquer"><icon name="copy-07"/></button></li>
                                <li v-if="$aclInterfaceValidator('weeboxshop.discount.update', item.id)"><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import DiscountService from './DiscountService.js';
    import Index from '../../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return DiscountService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/shop/discount/Index.vue